export default "__VITE_ASSET__BKh_r_uV__"